import GetFireDepartmentListRequestModelBase from '../_generated/modelBases/get-fire-department-list-request-model-base';

export default class GetFireDepartmentListRequestModel extends GetFireDepartmentListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
